import { gql } from '@apollo/client';
import { client } from '../client';

export interface ClientOperationReportItemInput {
  reportKey: string;
  opType: string;
  barCode: string;
  deviceId?: string;
  clientIp?: string;
  createdAtMs?: number;
  touchAtMs?: number;
  interceptAtMs?: number;
  interceptReason?: string;
  requestAtMs?: number;
  requestParamsJson?: string;
  requestHeadersJson?: string;
  responseAtMs?: number;
  responseResult?: string;
}

export interface ClientOperationReportBatchInput {
  opType?: string;
  items: ClientOperationReportItemInput[];
}

export interface ClientOperationReportBatchResult {
  acceptedKeys: string[];
  failedKeys: string[];
  switchValue: number;
}

export interface ReportClientOperationBatchResponse {
  reportClientOperationBatch: ClientOperationReportBatchResult;
}

export const REPORT_CLIENT_OPERATION_BATCH = gql`
  mutation ReportClientOperationBatch($input: ClientOperationReportBatchInput!) {
    reportClientOperationBatch(input: $input) {
      acceptedKeys
      failedKeys
      switchValue
    }
  }
`;

export async function reportClientOperationBatch(
  input: ClientOperationReportBatchInput
): Promise<ClientOperationReportBatchResult> {
  const resp = await client.mutate<ReportClientOperationBatchResponse, { input: ClientOperationReportBatchInput }>({
    mutation: REPORT_CLIENT_OPERATION_BATCH,
    variables: { input }
  });
  return resp.data?.reportClientOperationBatch || { acceptedKeys: [], failedKeys: [], switchValue: 0 };
}


